import { css } from "@emotion/react";
import primaryButtonCss from "assets/css/buttons/primaryButton.css";
import colors from "assets/css/colors";
import { contentCss } from "assets/css/content.css";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";
import lineHeight from "assets/css/lineHeight";

export const pageHeaderContainerCss = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const buttonCss = [
  primaryButtonCss,
  css`
    width: fit-content;
    &:active,
    &:hover {
      background-color: ${colors.darkBlue};
      box-shadow: unset;
    }
  `,
];

export const overlayCss = css`
  display: flex;
  justify-content: center;
`;

export const modalCss = css`
  margin: 120px auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw - 40px);
  max-width: 800px;
  background-color: blue;
`;

export const modalContentCss = css`
  height: 100%;
  width: 100%;
`;

export const modalContainerCss = [
  contentCss,
  css`
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    max-height: 750px;
    padding: 24px 20px;
    alignitems: center;
    justify-content: center;
  `,
];

export const leftCss = css`
  min-height: 600px;
  min-width: 330px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const sectionCss = css`
  display: flex;
  flex-direction: column;
  flex: 0 auto;
`;

export const titleCss = css`
  color: ${colors.mainBlack};
  font-size: ${fontSize.xl};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.md};
`;

export const inputWrapperCss = css`
  width: 350px;
`;

export const leftContainerCss = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const rightContainerCss = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const tabsContentCss = css`
  display: flex;
  gap: 100px;
  height: 100%;
  width: 100%;
`;
